import { useTranslation } from 'next-i18next';
import React, { } from 'react';
import BeseifTransaciones from './beseif/BeseifTransaciones';
import TopNavigation from '@/components/elements/TopNavigation';
import { ModoComprasMenu } from '@/objects/Beseif';
import { OpcionTopNavigation } from '@/objects/Menus';
import BeseifSeguimiento from './beseif/BeseifSeguimiento';

function ComprasMenu() {

    const { t } = useTranslation();

    const [seccionCompras, setSeccionCompras] = React.useState<ModoComprasMenu>(ModoComprasMenu.GENERAL);

    const opcionesBarraMenuMensajes: OpcionTopNavigation[] = [
        { nombre: t("menu:secciones.mis_compras.menu_modo.general"), tipoOpcion: ModoComprasMenu.GENERAL },
        { nombre: t("menu:secciones.mis_compras.menu_modo.seguimiento"), tipoOpcion: ModoComprasMenu.SEGUIMIENTO },
    ];

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%', flex: 1, minHeight: 0, margin: 0, padding: 0, overflow: 'hidden' }}>
            <TopNavigation
                opciones={opcionesBarraMenuMensajes}
                opcionActual={seccionCompras.toString()}
                setOpcionActual={(opcion: string) => setSeccionCompras(opcion as ModoComprasMenu)}
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 5,
                    flexShrink: 0,
                }}
            />
            {seccionCompras === ModoComprasMenu.GENERAL &&
                <BeseifTransaciones />
            }
            {seccionCompras === ModoComprasMenu.SEGUIMIENTO &&
                <BeseifSeguimiento />
            }
        </section>
    );
}

export default ComprasMenu;